import React, { useState, useRef, useLayoutEffect } from 'react';
import { NumericFormat } from 'react-number-format';
import slug from 'slug';
export const ResourceModalContent = ({ vars }) => {
    var _a, _b;
    const bgImage = vars.image ? `/${vars.image}` : '';
    const orientation = (vars.image_width && vars.image_height && vars.image_width > vars.image_height) ? 'landscape' : 'portrait';
    const address = ((_a = vars === null || vars === void 0 ? void 0 : vars.addresses) === null || _a === void 0 ? void 0 : _a[0]) || {};
    const links = (vars === null || vars === void 0 ? void 0 : vars.links) || [];
    const spacerRef = useRef(null);
    const titleColRef = useRef(null);
    const [spacerTop, setSpacerTop] = useState(null);
    let dynamicClasses = `EventModalContent--type--${slug(vars.eventType || vars.category)}`;
    dynamicClasses += vars.image ? ' EventModalContent--withImage' : ' EventModalContent--noImage';
    dynamicClasses += vars.image ? ` EventModalContent--orientation--${orientation}` : '';
    dynamicClasses += vars.summary || vars.image ? ' EventModalContent--withSummary' : '';
    useLayoutEffect(() => {
        const measure = () => {
            const spacer = spacerRef.current;
            const titleCol = titleColRef.current;
            if (!spacer || !titleCol)
                return;
            const spacerRect = spacer.getBoundingClientRect();
            const titleRect = titleCol.getBoundingClientRect();
            const offset = spacerRect.top - titleRect.top;
            setSpacerTop(Math.round(offset));
        };
        // measure after layout
        requestAnimationFrame(measure);
        const onResize = () => requestAnimationFrame(measure);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [vars.image_width, vars.image_height]);
    return (React.createElement("div", { "data-uid": vars.uid, className: `EventModalContent row no-gutters ${dynamicClasses}` },
        React.createElement("div", { "data-share-image": "title", className: "col EventModalContent__titleColContainer aspect-ratio-1x1" },
            React.createElement("div", { ref: titleColRef, className: "EventModalContent__titleCol" },
                React.createElement("div", { className: "EventModalContent__titleBackground", style: {
                        backgroundImage: `url('${bgImage || '/themes/townsendpa/images/logo.svg'}')`,
                        backgroundPosition: bgImage ? `left ${typeof spacerTop === 'number' ? spacerTop : (vars.image_height ? vars.image_height / 4 : 0)}px` : 'center',
                    } }),
                React.createElement("div", { ref: spacerRef, className: "EventModalContent__titleSpacer", style: { width: vars.image_width || 0, height: vars.image_height || 0 } }),
                React.createElement("div", { className: "EventModalContent__titleContent" },
                    vars.amount && (React.createElement("div", { className: "EventModalContent__amount" },
                        "$",
                        React.createElement(NumericFormat, { displayType: "text", value: vars.amount, thousandSeparator: "," }))),
                    React.createElement("h2", { className: "EventModalContent__title Heading Heading--h4", dangerouslySetInnerHTML: { __html: (_b = vars.title) === null || _b === void 0 ? void 0 : _b.replace(/\[/g, '<div><span>').replace(/\]/g, '</div></span>') } }),
                    Boolean(!vars.image) && (React.createElement("div", { className: "EventModalContent__titleMeta" },
                        address.city && (React.createElement("div", { className: "EventModalContent__city" },
                            address.city,
                            address.state && `, ${address.state}`)),
                        address.county && (React.createElement("div", { className: "EventModalContent__county" },
                            address.county,
                            " County")),
                        React.createElement("hr", { className: "EventModalContent__divider" }),
                        vars.funding_stream && (React.createElement("div", { className: "EventModalContent__fiscalYear" },
                            React.createElement("span", null, "Fiscal Year:"),
                            " ",
                            vars.year)),
                        vars.funding_stream && (React.createElement("div", { className: "EventModalContent__fundingStream" },
                            React.createElement("span", null, "Funded by:"),
                            " ",
                            vars.funding_stream)),
                        vars.category && (React.createElement("div", { className: "EventModalContent__category" },
                            React.createElement("span", null, "Entity:"),
                            " ",
                            vars.category)),
                        vars.recipient && (React.createElement("div", { className: "EventModalContent__recipient" },
                            React.createElement("span", null, "Recipient:"),
                            " ",
                            vars.recipient))))))),
        Boolean(vars.image || vars.summary) &&
            React.createElement("div", { "data-share-image": "content", className: "col EventModalContent__contentColContainer aspect-ratio-1x1" },
                React.createElement("div", { className: "EventModalContent__contentCol d-flex h-100" },
                    React.createElement("div", { className: "EventModalContent__content d-flex flex-column h-100" },
                        React.createElement("div", { className: "EventModalContent__contentOverflow" },
                            React.createElement("div", null,
                                Boolean(vars.image) && (React.createElement("div", { className: "EventModalContent__titleMeta" },
                                    address.city && (React.createElement("div", { className: "EventModalContent__city" },
                                        address.city,
                                        address.state && `, ${address.state}`)),
                                    address.county && (React.createElement("div", { className: "EventModalContent__county" },
                                        address.county,
                                        " County")),
                                    React.createElement("hr", { className: "EventModalContent__divider" }),
                                    vars.funding_stream && (React.createElement("div", { className: "EventModalContent__fiscalYear" },
                                        React.createElement("span", null, "Fiscal Year:"),
                                        " ",
                                        vars.year)),
                                    vars.funding_stream && (React.createElement("div", { className: "EventModalContent__fundingStream" },
                                        React.createElement("span", null, "Funded by:"),
                                        " ",
                                        vars.funding_stream)),
                                    vars.category && (React.createElement("div", { className: "EventModalContent__category" },
                                        React.createElement("span", null, "Entity:"),
                                        " ",
                                        vars.category)),
                                    vars.recipient && (React.createElement("div", { className: "EventModalContent__recipient" },
                                        React.createElement("span", null, "Recipient:"),
                                        " ",
                                        vars.recipient)))),
                                React.createElement("div", { className: "RawHTML pt-4", dangerouslySetInnerHTML: { __html: vars.summary } }),
                                React.createElement("div", { className: "my-3" }, links.map((link) => (React.createElement("a", { key: link.url, className: "Button Button--primary", href: link.url, target: "_blank" }, link.label)))))))))));
};
// end of ResourceModalContent
